import $http from "@/axios-instance";
import Swal from "sweetalert2";
import { validarPermisoComponente } from "@/plugins/acl";



/**
 * Generar procesos en segundo plano
 *
 */
export async function generateScheduling({ commit, state },payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`/background_processes/${state.type}`,payload);
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 6000
        });
    } catch (error) {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: true,
            timer: 5000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}


/**
 * Generar procesos en segundo plano
 *
 */
export async function generateSchedulingGlobal({ commit, state },payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`/background_processes/all-products`,payload);
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 6000
        });
    } catch (error) {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: true,
            timer: 5000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}


/**
 * Cargar procesos background
 *
 */
export async function loadProccessBackground({ commit, state },payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const urlParam = (state.is_global_report) ? `` : `/${payload.company_id}`;
        const response = await $http.get(`/background_processes/${payload.type}${urlParam}`)
        commit('setBackgroundProcess', response.data);
    } catch (error) {
        return Promise.reject(error.message)
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}


/**
 * Descargar el archivo generado en segundo plano.
 *
 * @param id
 */
export async function downloadReport({commit, state}, payload) {
    commit('dashboard/load', true, {root: true});
    const urlParam = (state.is_global_report) ? `global-report` : `file`;
    await $http({
        url: `background_processes/${payload.id}/${urlParam}`,
        method: 'POST',
        responseType: 'blob',
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        const file = payload.json['ruta_archivo'].split('/');
        window.downloadFile(response.data, file.at(-1))
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'No se encontro el archivo',
            showConfirmButton: true,
            timer: 5000
        });
    });
}

